import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="Footer">
            <p>
                <a
                    href="mailto:albordignon@gmail.com"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Desenvolvido por André Luís Bordignon
                </a>
            </p>
            <span>•</span>
            <a
                href="http://creativecommons.org/licenses/by-nc/4.0/"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img
                    alt="Licença Creative Commons"
                    src="https://i.creativecommons.org/l/by-nc/4.0/88x31.png"
                />
            </a>
            <p>
                <a
                    href="http://creativecommons.org/licenses/by-nc/4.0/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    CC BY-NC 4.0
                </a>
            </p>
        </footer>
    );
};

export default Footer;